import { createContext, useContext } from 'react';

import {
  FieldValues,
  UseFieldArrayAppend,
  UseFieldArrayRemove,
  UseFieldArrayReplace,
  UseFieldArrayUpdate
} from 'react-hook-form';

import { FieldArrayWithId } from 'react-hook-form/dist/types/fieldArray';

interface FieldArrayContext {
  fields: FieldArrayWithId[];
  append: UseFieldArrayAppend<FieldValues, any>;
  remove: UseFieldArrayRemove;
  update: UseFieldArrayUpdate<FieldValues, any>;
  replace: UseFieldArrayReplace<FieldValues, any>;
}

export const fieldArrayContext = createContext<FieldArrayContext>(
  {} as FieldArrayContext
);

export const useFieldArrayContext = () => {
  return useContext(fieldArrayContext);
};
